import { useState } from "react";
import VideoCard from "./VideoCard";
import VideoModal from "./VideoModal";
import { ShortsVideo } from "types/event";

interface Props {
  video: ShortsVideo;
  videos: ShortsVideo[];
}

export default function VideoSlider({ video, videos }: Props) {
  const [selectedVideo, setSelectedVideo] = useState<ShortsVideo | null>(null);

  const handleNext = () => {
    if (!selectedVideo) return;
    const currentIndex = videos.findIndex((v) => v._id === selectedVideo._id);
    const nextIndex = (currentIndex + 1) % videos.length;
    const nextVideo = videos[nextIndex];
    setSelectedVideo(nextVideo);
  };

  const handlePrev = () => {
    if (!selectedVideo) return;
    const currentIndex = videos.findIndex((v) => v._id === selectedVideo._id);
    const prevIndex = (currentIndex - 1 + videos.length) % videos.length;
    const prevVideo = videos[prevIndex];
    setSelectedVideo(prevVideo);
  };

  return (
    <>
      <div className="flex overflow-x-auto keen-slider__slide">
        <VideoCard
          key={video._id}
          video={video}
          onClick={() => {
            setSelectedVideo(video);
          }}
        />
      </div>

      {selectedVideo && (
        <VideoModal
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
          onNext={handleNext}
          onPrev={handlePrev}
        />
      )}
    </>
  );
}
